import PostListRoute from './PostListRoute';

export default PostListRoute;
